import React from 'react'
import { SearchBarTable } from 'hljd'
import getColumns from './columns'
import { inject } from 'mobx-react'
import Empty, { ZhiTuiBao } from '../../Empty'

export default inject('store')(({ store }) => (
  <SearchBarTable
    store={store}
    locale={{
      emptyText: <Empty content={ZhiTuiBao} />
    }}
    columns={getColumns(store)}
  />
))
